import React from "react";
import { ShieldCheck, Lock, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const safetyFeatures = [{
  id: 1,
  title: "Curated Perspectives",
  description: "Deep dives into the hidden gems of the everyday, uncovering stories that often go unnoticed."
}, {
  id: 2,
  title: "Visual Narratives",
  description: "High-resolution photography paired with evocative prose to transport you to new horizons."
}, {
  id: 3,
  title: "Daily Inspiration",
  description: "A consistent stream of thought-provoking content designed to spark your own curiosity."
}];
export default function MeetTheExplorer() {
  return <section data-section-id="252682" id="meet-the-explorer" className="bg-background text-foreground">
      <div className="max-w-screen-2xl mx-auto bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
        {}
        <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_top_right,_var(--color-primary)_0%,_transparent_40%)] pointer-events-none" />
        
        <div className="page-container max-w-6xl mx-auto relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            
            {}
            <div className="flex flex-col items-start">
              <Badge variant="secondary" className="mb-6 bg-secondary text-secondary-foreground hover:bg-secondary/90 border-none font-mono uppercase tracking-widest text-xs">
                <ShieldCheck className="w-4 h-4 mr-2 text-primary" />
                Hello
              </Badge>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold font-default mb-6 leading-tight text-foreground font-serif tracking-tight">
                I'm Alex, your guide to the everyday.
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground mb-10 font-default max-w-xl leading-relaxed">
                Exploring the intersection of simple living and profound discovery through a lens of modern serenity and curious observation.
              </p>
              
              <div className="flex flex-col gap-6 mb-10 w-full max-w-xl">
                {safetyFeatures.map((feature, i) => <div key={feature.id} data-index={i} className="flex gap-4 items-start">
                    <div className="shrink-0 mt-1 bg-primary/10 p-2 rounded-md">
                      {i === 0 && <ShieldCheck className="w-6 h-6 text-primary" />}
                      {i === 1 && <Lock className="w-6 h-6 text-primary" />}
                      {i === 2 && <CircleCheck className="w-6 h-6 text-primary" />}
                    </div>
                    <div>
                      <h3 className="font-semibold text-xl text-foreground font-default mb-1">
                        {feature.title}
                      </h3>
                      <p className="text-muted-foreground font-default leading-relaxed">
                        {feature.description}
                      </p>
                    </div>
                  </div>)}
              </div>
              
              <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                <Button size="lg" asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold text-base px-10 h-14 rounded-lg shadow-lg shadow-primary/10 transition-all hover:scale-105 active:scale-95">
                  <Link to="/TheArchivePage">
                     Read the Story
                  </Link>
                </Button>
              </div>
            </div>
            
            {}
            <div className="relative w-full max-w-2xl mx-auto lg:mx-0">
              <div className="absolute -inset-4 bg-primary/5 rounded-3xl transform rotate-3 scale-105 -z-10 hidden md:block" />
              <div className="absolute -inset-4 bg-secondary/30 rounded-3xl transform -rotate-2 scale-105 -z-10 hidden md:block" />
              
              <div className="rounded-2xl overflow-hidden shadow-xl border border-border bg-card">
                <AspectRatio ratio={4 / 3}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686004/img/explorer_profile_portrait.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686004/img/explorer_profile_portrait.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686004/img/explorer_profile_portrait.png-wvc-sizes" alt="Portrait of the Daily Explorer" className="w-full h-full object-cover" loading="lazy" />
                  
                  {}
                  <div className="absolute bottom-6 left-6 right-6 bg-background/80 backdrop-blur-md p-4 rounded-xl border border-border/50 shadow-md flex items-center gap-4">
                    <div className="bg-primary/10 p-3 rounded-lg shrink-0">
                      <ShieldCheck className="w-8 h-8 text-primary" />
                    </div>
                    <div>
                      <p className="font-semibold text-foreground font-default text-lg">Authentic Voice</p>
                      <p className="text-sm text-muted-foreground font-default">Every story is lived, breathed, and captured by hand.</p>
                    </div>
                  </div>
                </AspectRatio>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}